/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fw_Kits_Region_IdInputs */

const en_fw_kits_region_id = /** @type {(inputs: Fw_Kits_Region_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesia`)
};

const id_fw_kits_region_id = /** @type {(inputs: Fw_Kits_Region_IdInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indonesia`)
};

/**
* | output |
* | --- |
* | "Indonesia" |
*
* @param {Fw_Kits_Region_IdInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const fw_kits_region_id = /** @type {((inputs?: Fw_Kits_Region_IdInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fw_Kits_Region_IdInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_fw_kits_region_id(inputs)
	return en_fw_kits_region_id(inputs)
});